import * as Joi from "joi";
import parsePhoneNumber from 'libphonenumber-js';
import i18n from "i18n";

export const DRIVER_SCHEMA = Joi.object({
    name: Joi.string()
        .required()
        .empty('')
        .label(i18n.t("Full Name"))
        .messages({ 'any.required': `{#label} ${i18n.t("validationErrors.isRequired")}` }),
    phone: Joi.string()
        .label(i18n.t("Phone"))
        .empty('')
        .messages({
            'any.required': `{#label} ${i18n.t("validationErrors.isRequired")}`,
        })
        .required()
        .custom((value, helper) => {
            const parsedPhone = parsePhoneNumber(value, { extract: true });
            if (!parsedPhone || !parsedPhone.isValid())
                return helper.message(i18n.t("validationErrors.isValidPhone"));
            return true
        }),
    password: Joi.string()
        .required()
        .empty('')
        .min(6)
        .label(i18n.t("Password")).messages({
            'any.required': `{#label} ${i18n.t("validationErrors.isRequired")}`,
            'string.empty': `{#label} ${i18n.t("validationErrors.isEmpty")}`,
            'string.min': `{#label} ${i18n.t("validationErrors.minChar", { length: 6 })}`,
        }),
})
export const DRIVER_SCHEMA_WITHOUT_PASSWORD = Joi.object({
    name: Joi.string()
        .required()
        .empty('')
        .label(i18n.t("Full Name"))
        .messages({ 'any.required': `{#label} ${i18n.t("validationErrors.isRequired")}` }),
    phone: Joi.string()
        .label(i18n.t("Phone"))
        .empty('')
        .messages({
            'any.required': `{#label} ${i18n.t("validationErrors.isRequired")}`,
        })
        .required()
        .custom((value, helper) => {
            const parsedPhone = parsePhoneNumber(value, { extract: true });
            if (!parsedPhone || !parsedPhone.isValid())
                return helper.message(i18n.t("validationErrors.isValidPhone"));
            return true
        }),
})